import cx from 'classnames'
import styles from './FloatingIconButton.module.css'
import { Icon, type IconName } from '@/components/Icon'
import { m, type MotionNodeLayoutOptions } from 'motion/react'
import type { Transition } from 'motion-dom'
import { RawButton } from '@/components/Button'
import { Tooltip, TooltipTrigger } from '@/components/Tooltip'

export interface FloatingIconButtonProps {
  onPress?: () => unknown
  isDisabled?: boolean
  layout?: MotionNodeLayoutOptions['layout']
  layoutId?: string
  name: IconName
  label: string
  initial?: boolean
  transition?: Transition
  testId?: string
}

const MotionRawButton = m.create(RawButton)

/**
 * The FloatingIconButton
 */
export function FloatingIconButton({
  label,
  onPress,
  layoutId,
  layout,
  transition,
  name,
  initial,
  isDisabled,
  testId,
}: FloatingIconButtonProps) {
  return (
    <TooltipTrigger>
      <MotionRawButton
        isDisabled={isDisabled}
        onPress={onPress}
        layout={layout}
        layoutId={layoutId}
        transition={transition}
        initial={initial}
        testId={testId}
        className={({ isHovered, isPressed, isDisabled, isFocusVisible }) =>
          cx(
            styles.root,
            isHovered && styles.hover,
            isPressed && styles.pressed,
            isFocusVisible && styles.focusVisible,
            isDisabled && styles.disabled,
          )
        }
      >
        <Icon name={name} />
      </MotionRawButton>
      <Tooltip>{label}</Tooltip>
    </TooltipTrigger>
  )
}
